export default {
  successFlashMessage: 'successFlashMessage',
  errorFlashMessage: 'errorFlashMessage',
}
